/**
 * Validate a hand-typed model year for manual vehicle entry.
 * Returns the message to show under the field, or null when the year is acceptable.
 * Shared by the Add Vehicle form and the Add/Edit Vehicle card so both accept the same years.
 */
export function getManufacturingYearError(raw: string | number | undefined | null): string | null {
  const trimmed = raw === undefined || raw === null ? '' : String(raw).trim();
  if (!trimmed) {
    return 'Year is required';
  }
  if (!/^\d{4}$/.test(trimmed)) {
    return 'Enter a full 4-digit model year (e.g. 2020)';
  }
  const year = parseInt(trimmed, 10);
  const currentYear = new Date().getFullYear();
  const maxYear = currentYear + 1;
  if (year < 1900 || year > maxYear) {
    return `Year must be between 1900 and ${maxYear}`;
  }
  return null;
}
